import { Skeleton } from "@mui/material";

export const EntriesSkeletons = ({ total = 4 }: { total?: number }) => {
    const elements = [];
    for (let i = 0; i < total; i++) {
        elements.push(i);
    }

    return elements.map((k) => <Skeleton data-testid={"skeleton"} key={k} variant="rounded" height="80px" />);
};
